import { render, staticRenderFns } from "./DepartmentsList.vue?vue&type=template&id=cd18e678&scoped=true&"
import script from "./DepartmentsList.vue?vue&type=script&lang=js&"
export * from "./DepartmentsList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsList.vue?vue&type=style&index=0&id=cd18e678&lang=scss&scoped=true&"
import style1 from "./DepartmentsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd18e678",
  null
  
)

export default component.exports